import { FormControl, Menu, Box, Grid, FormControlLabel, Divider, Button } from '@material-ui/core'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import PositiveSwitch from './form_components/switch';
import { getBaseStationID, getOrganisationId } from 'lib/utils/common_utils';
import { ToastMessageContext } from 'lib/contexts/message_context';

import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import { useTimeoutEffect } from 'lib/hooks/useTimeoutEffect';
export default function MultipleBaseFilter(props) {

    const { selectedBase, setSelectedBase, marginLeft } = props
    const [bases, setBases] = useState([]);
    const [anchorBase, setAnchorBase] = useState(null);
    const [baseButton, setBaseButton] = useState(false)
    const message = useContext(ToastMessageContext)
    const handleBaseClick = (event) => {
        setAnchorBase(event.currentTarget);
        setBaseButton(!baseButton)
    };
    const filterChangeHandler = (e) => {
        const { name, value, checked } = e.target
        let value1 = bases.map((item) => {

            if (item.id === parseInt(value)) {
                item.status = !item.status
            }
            return item
        })

        // setRunTable(false)
        setSelectedBase((prevState) => [...prevState, parseInt(value)])
        if (!checked) {
            if (selectedBase.length > 1) {
                let item = selectedBase.filter((item) => item !== parseInt(value))

                setSelectedBase(item);

            }
            else {
                setSelectedBase([])
            }

        }

    }


    const getBaseStation = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            order_by: 'station'
        }
        MaintenanceServices.getBaseStation(params)
            .then((res) => {
                if (res) {


                    let data = res.data
                    if (data.length > 0) {
                        let value = data.map((item) => ({
                            ...item,
                            status: getBaseStationID() === item.id ? true : false
                        }))
                        setBases(value);
                    }
                    else {

                        setBases(res.data);

                    }


                }

            })
            .catch((err) => {
                message.showToastMessage({
                    message: "Something went wrong. Try again!",
                    variant: "error",
                });

            });
    };
    useTimeoutEffect(getBaseStation, 0)
    const ITEM_HEIGHT = 78;

    return (
        <FormControl style={{ marginLeft: marginLeft ?? "" }}>
            <Button variant={anchorBase ? "contained" : "text"} size="small" aria-haspopup="true" onClick={handleBaseClick} endIcon={baseButton ? <ArrowDropUp /> : <ArrowDown />} style={{ fontSize: "14px", backgroundColor: anchorBase ? '#efefef' : "" }}>
                {selectedBase.length > 0 ? `Base(${selectedBase.length})` : 'Base(All)'}

            </Button>
            <Menu
                id="Base"
                anchorEl={anchorBase}
                keepMounted
                open={Boolean(anchorBase)}
                onClose={() => {
                    setAnchorBase(null)
                    setBaseButton(!baseButton)
                }}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                style={{ marginTop: '41px' }}
                TransitionProps={false}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.2,
                        width: '39ch',
                        position: 'fixed',
                        top: '260px',

                    },
                }}
            >
                {
                    bases?.map((base, index) => {
                        return <Box>
                            <Grid container spacing={2}>
                                <Grid item xs={1}></Grid>
                                <Grid item xs={8} style={{
                                    display: "flex", alignItems: "center", fontSize: "14px",

                                }}>
                                    <label>{base.station}</label>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControlLabel
                                        style={{ alignSelf: "flex-end" }}
                                        control={<PositiveSwitch
                                            checked={base.status}
                                            value={base.id}
                                            // onChange={(e) => handleChange(e, option.id)}
                                            onChange={(e) => { filterChangeHandler(e, index) }}
                                            name={base.station} />}
                                    // name="base"
                                    />
                                </Grid>
                            </Grid>
                            <Grid><Divider variant="middle" /></Grid>
                        </Box>
                    }

                    )}
            </Menu>
        </FormControl>
    )
}
